// AppShell — pebble TopBar + SideNav rail + outlet + command palette + toasts.

import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { SkipLink } from "@/components/a11y/SkipLink";
import { SideNav } from "@/components/navigation/SideNav";
import { TopBar } from "@/components/navigation/TopBar";
import { CommandPalette } from "@/components/navigation/CommandPalette";
import { NotificationsPanel } from "@/components/navigation/NotificationsPanel";
import { ToastStack } from "@/components/primitives/Toast";
import { useUiStore } from "@/store/ui";

export function AppShell() {
  const setCommandOpen = useUiStore((s) => s.setCommandOpen);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setCommandOpen(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [setCommandOpen]);

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", background: "var(--md-bg)", color: "var(--md-on-surface)" }}>
      <SkipLink />
      <TopBar />
      <div style={{ display: "grid", gridTemplateColumns: "240px 1fr", flex: 1, minHeight: 0 }} className="lex-shell-body">
        <SideNav />
        <main id="main-content" tabIndex={-1} style={{ minWidth: 0, overflow: "auto" }}>
          <Outlet />
        </main>
      </div>
      <CommandPalette />
      <NotificationsPanel />
      <ToastStack />
    </div>
  );
}

export default AppShell;
